import { createContext, useContext, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useSearchParams } from "react-router-dom";
import { buildSubDomain, envChangeType, envType } from "../plugins/utils";

const DeviceContext = createContext({
  isMobile: false,
});

export const DeviceContextProvider = ({ children }) => {
  const [params] = useSearchParams();
  const isMobile = useMediaQuery({ query: "(max-width: 450px)" });

  useEffect(() => {
    if (isMobile) return;
    if (envChangeType("REACT_APP_PC_URL") === "") return;

    // 91uucny 在 production 環境下，需要特別處理跳轉 domain
    const domain = envChangeType("REACT_APP_SPECIAL_DIRECT", envType.BOOLEAN)
      ? buildSubDomain("web")
      : envChangeType("REACT_APP_PC_URL");
    const target = `${domain}${window.location.search}`;

    window.location.replace(target);
  }, [params, isMobile]);

  return (
    <DeviceContext.Provider
      value={{
        isMobile,
      }}
    >
      {children}
    </DeviceContext.Provider>
  );
};

export const useDevice = () => {
  const DeviceValue = useContext(DeviceContext);
  return DeviceValue;
};
